import type { CurrentUser } from '@/types'

/**
 * Where "Become a sitter" should lead. The sitter wizard (/sitters/new) needs
 * a session, and a visitor who clicks it used to land on a bare login form
 * with no explanation. A visitor goes to registration instead; the `for`
 * param lets the form say "create an account, then set up your sitter
 * profile". A signed-in user goes straight to the wizard.
 */
export function becomeSitterHref(currentUser?: CurrentUser | null): string {
  return currentUser ? '/sitters/new' : '/register?for=sitter'
}
